import JSONPath from "jsonpath";
import router from '@/router';
import { Toast } from "vant";
var qs = require("qs");
// let baseUrl = "";
// let appKey = "";
// let baseUserUrl = "";
// let appUserKey = "";
// let payUrl = "";
// let ossCode = "";
// let ossUrl = "";
// let rzcenterUrl = "";
// let getPay = "";
// let orderUrl = "";
// let expressUrl = "";
// let phUrl = "";
// let chewu = "";
// let guoyinToken = "";
// let VXUrl =
//   "https://api.weixin.qq.com/cgi-bin/media/get?access_token={0}&media_id={1}";

// if (process.env.NODE_ENV == "development" || process.env.NODE_ENV == "testing") {
//   console.log(process.env);
//   baseUrl = process.env.API_PATH_DEV;
//   appKey = process.env.APPKEY_DEV;
//   baseUserUrl = process.env.API_USER_PROD; //用户中心
//   appUserKey = process.env.APPUSERKEY_PROD; //用户中心
//   payUrl = process.env.PAY_PROD; //支付站点
//   ossCode = process.env.OSS_CODE_TEST;
//   ossUrl = process.env.OSS_ADDRESS_TEST;
//   rzcenterUrl = process.env.RZCENTERURL_DEV;
//   getPay = process.env.GETPAY_PROD;
//   orderUrl = process.env.ORDER__PROD;
//   expressUrl = process.env.EXPRESS_PROD;
//   chewu = process.env.CHEWU;
//   phUrl = process.env.PHURL;
//   // phUrl = process.env.PHURL;
//   // funderId = process.env.FUNDERID;
//   guoyinToken = process.env.GUOYINTOKEN;
// }
// if (process.env.NODE_ENV == "pre"||process.env.NODE_ENV == "production") {
//   console.log(process.env);
//   baseUrl = process.env.API_PATH_PROD;
//   appKey = process.env.APPKEY_PROD;
//   baseUserUrl = process.env.API_USER_PROD;
//   appUserKey = process.env.APPUSERKEY_PROD;
//   payUrl = process.env.PAY_PROD; //支付站点
//   ossCode = process.env.OSS_CODE_TEST;
//   ossUrl = process.env.OSS_ADDRESS_TEST;
//   rzcenterUrl = process.env.RZCENTERURL_DEV;
//   getPay = process.env.GETPAY_PROD;
//   orderUrl = process.env.ORDER__PROD;
//   expressUrl = process.env.EXPRESS_PROD;
//   phUrl = process.env.PHURL;
//   chewu = process.env.CHEWU;
//   // funderId = process.env.FUNDERID;
//   guoyinToken = process.env.GUOYINTOKEN;
// }

// 引用axios
var axios = require("axios");
import myStorage from "../assets/js/sessionStorage";
import { fail } from "assert";

// 创建一个 axios 实例
// const service = axios.create({
//   // baseURL: process.env.VUE_APP_BASE_API,
//   baseURL: window.configs.VUE_APP_BASE_API,
//   timeout: 50000 // 请求超时时间
// });
// 响应拦截器
// const responseInterceptor = (axios)=>{
//   axios.interceptors.response.use((response)=>{
//     // dataAxios 是 axios 返回数据中的 data
//     const dataAxios = response.data;
//     // 这个状态码是和后端约定的
//     const code = response.status;
//     if (code === undefined) {
//       // 如果没有 code 代表这不是项目后端开发的接口
//       return dataAxios;
//     } else {
//       switch (code) {
//         case 0:
//             return dataAxios;
//         case 200:
//             return dataAxios;
//         case 401:
//             // [ 示例 ] 其它和后台约定的 code
//             // router.push({
//             //   name: 'login'
//             // });
//             this.$router.push({
//               path:
//                 "/vhaBinding?openid=" + this.myStorage.Get("openId") + "&appId=" + this.myStorage.Get("appId")
//             });
//             errorCreate(`登录过期,请重新登录！`);
//             break;
//         case 403:
//             // [ 示例 ] 其它和后台约定的 code
//             errorCreate(`提示没有权限！`);
//             break;
//         case 500:
//             // [ 示例 ] 其它和后台约定的 code
//             // errorCreate(`[ code: 500 ] ${dataAxios.message}`);
//             errorCreate(`${dataAxios.message}`);
//             break;
//         default:
//             // 不是正确的 code
//             errorCreate(`${dataAxios.msg}: ${response.config.url}`);
//             break;
//       }
//     }
//   })
// }

function Ajax(type, url, data, success, failed) {
  // 创建ajax对象
  var xhr = null;
  if (window.XMLHttpRequest) {
    xhr = new XMLHttpRequest();
  } else {
    xhr = new ActiveXObject("Microsoft.XMLHTTP");
  }

  var type = type.toUpperCase();
  // 用于清除缓存
  var random = Math.random();

  if (typeof data == "object") {
    var str = "";
    for (var key in data) {
      str += key + "=" + data[key] + "&";
    }
    data = str.replace(/&$/, "");
  }

  if (type == "GET") {
    if (data) {
      xhr.open(
        "GET",
        "http://scrm2018-api.lunz.cn/api/" + url + "?" + data,
        true
      );
    } else {
      xhr.open(
        "GET",
        "http://scrm2018-api.lunz.cn/api/" + url + "?t=" + random,
        true
      );
    }
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.setRequestHeader("AppKey", "13095435-444a-11e8-b235-7cd30abc9af2");
    xhr.send();
  } else if (type == "POST") {
    xhr.open("POST", "http://scrm2018-api.lunz.cn/api/" + url, true);
    // 如果需要像 html 表单那样 POST 数据，请使用 setRequestHeader() 来添加 http 头。
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.setRequestHeader("AppKey", "13095435-444a-11e8-b235-7cd30abc9af2");
    xhr.send(data);
  }
  // 处理返回数据
  xhr.onreadystatechange = function() {
    if (xhr.readyState == 4) {
      if (xhr.status == 200) {
        success(xhr.responseText);
      } else {
        if (failed) {
          failed(xhr.status);
        }
      }
    }
  };
}

function handleAxios(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params);
  }
  axios({
    method: method,
    url: url,
    data: method === "POST" || method === "PUT" ? params : null,
    params: method === "GET" || method === "DELETE" ? params : null,
    headers: {
      appkey: escape(appKey),
      AUDL_USER:
        sessionStorage.getItem("AUDL_USER") == null
          ? ""
          : JSON.parse(sessionStorage.getItem("AUDL_USER")),
      authToken:
        sessionStorage.getItem("authtoken") == null
          ? ""
          : JSON.parse(sessionStorage.getItem("authtoken"))
    },
    withCredentials: false,
    baseURL: baseUrl
  })
    .then(function(res) {
      if (success) {
        success(res.data);
      } else {
        failure(res.data);
      }
    })
    .catch(function(err) {
      let res = err.response;
      goBinding(res.status)
      if (err) {
        // window.alert("api error,HTTP CODE: " + err);
      }
    });
}

function handleorderAxios(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params);
  }
  axios({
    method: method,
    url: url,
    data: method === "POST" || method === "PUT" ? params : null,
    params: method === "GET" || method === "DELETE" ? params : null,
    headers: {
      appkey: escape(appKey),
      AUDL_USER:
        sessionStorage.getItem("AUDL_USER") == null
          ? ""
          : JSON.parse(sessionStorage.getItem("AUDL_USER")),
      authToken:
        sessionStorage.getItem("authtoken") == null
          ? ""
          : JSON.parse(sessionStorage.getItem("authtoken"))
    },
    withCredentials: false,
    baseURL: orderUrl
  })
    .then(function(res) {
      if (success) {
        success(res.data);
      } else {
        failure(res.data);
      }
    })
    .catch(function(err) {
      let res = err.response;
      goBinding(res.status)
      if (err) {
        // window.alert("api error,HTTP CODE: " + err);
      }
    });
}

function handleAxiosSts(method, url, params, token, success, failure, err) {
  axios({
    method: method,
    url: url,
    data: method === "POST" || method === "PUT" ? qs.parse(params) : null,
    params: method === "GET" || method === "DELETE" ? qs.parse(params) : null,
    timeout: 10000,
    dataType: "json",
    withCredentials: false,
    baseURL: ossUrl,
    headers: {
      Authorization: token
    }
  })
    .then(function(res) {
      if (res.data == "") {
        success(res);
      }
      if (success) {
        success(res.data);
      } else {
        failure(res.data);
      }
    })
    .catch(function(error) {
      let res = error.response;
      goBinding(res.status)
      failure(error);
    });
}

// 国银普惠政策管家api
function handleAxiosGroYin(method, url, params, success, failure) {
  axios({
    method: method,
    url: url,
    data: method === "POST" || method === "PUT" ? qs.parse(params) : null,
    params: method === "GET" || method === "DELETE" ? qs.parse(params) : null,
    timeout: 10000,
    // dataType: "json",
    withCredentials: false,
    baseURL: phUrl,
    // headers: {
    //   authToken:'a83c5589-e482-41ad-ac7c-680a47766ff4',
    //   appkey: '76a20000-3e08-0016-6b8d-08d9530b4269'
    // },
  })
    .then(function(res) {
      // if (res.data == "") {
      //   success(res);
      // }
      if (success || res.status === 200) {
        success(res.data);
      } else {
        failureHandler(failure, res.data);
      }
    })
    .catch(function(error) {
      let res = error.response;
      if (error&&res) {
        failureHandler(failure, res.data);
        // window.alert("api error,HTTP CODE: " + err);
      }
    });
}
// 国银普惠车务api
function handleAxiosGroYinCheWu(method, url, params, success, failure) {
  axios({
    method: method,
    url: url,
    data: method === "POST" || method === "PUT" ? qs.parse(params) : null,
    params: method === "GET" || method === "DELETE" ? qs.parse(params) : null,
    timeout: 10000,
    dataType: "json",
    withCredentials: false,
    baseURL: chewu,
    // headers: {
    //   authToken:'a83c5589-e482-41ad-ac7c-680a47766ff4',
    //   appkey: '76a20000-3e08-0016-6b8d-08d9530b4269'
    // },
  })
    .then(function(res) {
      if (success || res.status === 200) {
        success(res.data);
      } else {
        failureHandler(failure, res.data);
      }
    })
    .catch(function(error) {
      let res = error.response;
      if (error&&res) {
        failureHandler(failure, res.data);
      }
    });
}
// 国银普惠鉴权api
function handleAxiosGroYinJQ(method, url, params, success, failure) {
  axios({
    method: method,
    url: url,
    data: method === "POST" || method === "PUT" ? params : null,
    params: method === "GET" || method === "DELETE" ? qs.parse(params) : null,
    timeout: 10000,
    withCredentials: false,
    baseURL: rzcenterUrl,
    headers: {
      Authorization: guoyinToken,
      'Content-type': "multipart/form-data",
    },
  })
    .then(function(res) {
      // if (res.data == "") {
      //   success(res);
      // }
      if (success || res.status === 200) {
        success(res.data);
      } else {
        failureHandler(failure, res.data);
      }
    })
    .catch(function(error) {
      let res = error.response;
      if (error&&res) {
        failureHandler(failure, res.data);
        // window.alert("api error,HTTP CODE: " + err);
      }
    });
}

//认证中心获取code
function rzCenterAxios(method, url, params, success, failure) {
  axios({
    method: method,
    url: url,
    data: qs.stringify(params),
    withCredentials: false,
    baseURL: rzcenterUrl,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
    }
  })
    .then(function(res) {
      if (success) {
        success(res.data);
      } else {
        failure(res.data);
      }
    })
    .catch(function(err) {
      let res = err.response;
      goBinding(res.status)
      if (err) {
        console.log("api error,HTTP CODE: " + err);
        // Toast.fail("数据异常");
      }
    });
}

function handleUserAxios(method, url, params, headers, success, failure) {
  if (params) {
    params = filterNull(params);
  }
  let header = {
    appkey: escape(appUserKey),
    "X-XSS-Protection": "1",
    "X-Content-Type-Options": "nosniff"
  };
  axios({
    method: method,
    url: url,
    data: method === "POST" || method === "PUT" ? params : null,
    params: method === "GET" || method === "DELETE" ? params : null,
    headers: Object.assign(header, headers),
    withCredentials: false,
    baseURL: baseUserUrl
  })
    .then(function(res) {
      if (success) {
        success(res.data);
      } else {
        failure(res.data);
      }
    })
    .catch(function(err) {
      let res = err.response;
      goBinding(res.status)
      if (err) {
        // window.alert("api error,HTTP CODE: " + err);
      }
    });
}

function pay(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params);
  }
  axios({
    method: method,
    url: url,
    data: method === "POST" || method === "PUT" ? params : null,
    params: method === "GET" || method === "DELETE" ? params : null,
    headers: {
      appkey: escape(appKey),
      AUDL_USER:
        sessionStorage.getItem("AUDL_USER") == null
          ? ""
          : JSON.parse(sessionStorage.getItem("AUDL_USER")),
      authToken:
        sessionStorage.getItem("authtoken") == null
          ? ""
          : JSON.parse(sessionStorage.getItem("authtoken"))
    },
    withCredentials: false,
    baseURL: payUrl
  })
    .then(function(res) {
      if (success) {
        success(res.data);
      } else {
        goBinding(res.status)
        failure(res.data);
      }
    })
    .catch(function(err) {
      let res = err.response;
      if (err) {
        // window.alert("api error,HTTP CODE: " + err);
      }
    });
}

function failureHandler(failure, data) {
  if (failure) {
    failure(data);
  } else {
    const message = data.message ? data.message : "系统异常";
    Toast.fail(message);
  }
}

// 签署订单
function handleSign(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params);
  }
  axios({
    method: method,
    url: url,
    data: method === "POST" || method === "PUT" ? params : null,
    params: method === "GET" || method === "DELETE" ? params : null,
    headers: {
      appkey: escape(appKey),
      AUDL_USER:
      localStorage.getItem("AUDL_USER") == null ? "" : JSON.parse(localStorage.getItem("AUDL_USER")),
      authtoken: localStorage.getItem("authToken") == null ? "" : localStorage.getItem("authToken")
      //   AUDL_USER: "76a20000-3e08-0016-80af-08d8f428f9e6",
      //   authToken: "5b4fc4f5-8504-4afa-a787-473fa3bec4cc"
    },
    withCredentials: false,
    baseURL: getPay
  })
    .then(function(res) {
      if (success) {
        success(res.data);
      } else {
        failureHandler(failure, res.data);
      }
    })
    .catch(function(err) {
      let res = err.response;
      if (err&&res) {
        goSignPlatform(res.status)
        failureHandler(failure, res.data);
        // window.alert("api error,HTTP CODE: " + err);
      }
    });
    // responseInterceptor(axios)
}

// 401跳转签署平台登陆页
function goSignPlatform(code){
  if(code == 401) {
    localStorage.removeItem("authToken");
    localStorage.removeItem("corpId")
    router.push({ path: `/signPlatform` });
  }
}

function handleSF(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params);
  }
  axios({
    method: method,
    url: url,
    data: method === "POST" || method === "PUT" ? params : null,
    params: method === "GET" || method === "DELETE" ? params : null,
    baseURL: getPay
  })
    .then(function(res) {
      console.log("api error,HTTP CODE00: " + res);
      if (success) {
        success(res.data);
      } else {
        console.log("api error,HTTP CODE11: " + failure, res.data);
        failureHandler(failure, res.data);
      }
    })
    .catch(function(err) {
      let res = err.response;
      // goBinding(res.status)
      if (err&&res) {
        console.log("api error,HTTP CODE22: " + failure, res.data);
        failureHandler(failure, res.data);
        // window.alert("api error,HTTP CODE: " + err);
      }
    });
    // responseInterceptor(axios)
}

function handleSFSpe(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params);
  }
  axios({
    method: method,
    url: url,
    data: method === "POST" || method === "PUT" ? params : null,
    params: method === "GET" || method === "DELETE" ? params : null,
    baseURL: getPaySpe
  })
    .then(function(res) {
      console.log("api error,HTTP CODE00: " + res);
      if (success) {
        success(res.data);
      } else {
        console.log("api error,HTTP CODE11: " + failure, res.data);
        failureHandler(failure, res.data);
      }
    })
    .catch(function(err) {
      let res = err.response;
      // goBinding(res.status)
      if (err&&res) {
        console.log("api error,HTTP CODE22: " + failure, res.data);
        failureHandler(failure, res.data);
        // window.alert("api error,HTTP CODE: " + err);
      }
    });
    // responseInterceptor(axios)
}


function handlezf(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params);
  }
  axios({
    method: method,
    url: url,
    data: method === "POST" || method === "PUT" ? params : null,
    params: method === "GET" || method === "DELETE" ? params : null,
    headers: {
      appkey: escape(appKey),
      AUDL_USER:
        sessionStorage.getItem("AUDL_USER") == null
          ? ""
          : JSON.parse(sessionStorage.getItem("AUDL_USER")),
      authToken:
        sessionStorage.getItem("authToken") == null
          ? ""
          : JSON.parse(sessionStorage.getItem("authToken"))
      //   AUDL_USER: "76a20000-3e08-0016-80af-08d8f428f9e6",
      //   authToken: "5b4fc4f5-8504-4afa-a787-473fa3bec4cc"
    },
    withCredentials: false,
    baseURL: getPay
  })
    .then(function(res) {
      if (success) {
        success(res.data);
      } else {
        failureHandler(failure, res.data);
      }
    })
    .catch(function(err) {
      let res = err.response;
      goBinding(res.status)
      if (err&&res) {
        failureHandler(failure, res.data);
        // window.alert("api error,HTTP CODE: " + err);
      }
    });
    // responseInterceptor(axios)
}
// 处理快递方面的接口
function handleExpress(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params);
  }
  axios({
    method: method,
    url: url,
    data: method === "POST" || method === "PUT" ? params : null,
    params: method === "GET" || method === "DELETE" ? params : null,
    headers: {
      appkey: escape(appKey),
      AUDL_USER:
        sessionStorage.getItem("AUDL_USER") == null
          ? ""
          : JSON.parse(sessionStorage.getItem("AUDL_USER")),
      authToken:
        sessionStorage.getItem("authtoken") == null
          ? ""
          : JSON.parse(sessionStorage.getItem("authtoken"))
    },
    withCredentials: false,
    baseURL: expressUrl
  })
    .then(function(res) {
      if (success) {
        success(res.data);
      } else {
        failure(res.data);
      }
    })
    .catch(function(err) {
      let res = err.response;
      goBinding(res.status)
      if (err) {
        // window.alert("api error,HTTP CODE: " + err);
      }
    });
}
// 401跳转绑定页
function goBinding(code){
  if(code == 401) {
    const appId = myStorage.Get("appId")?myStorage.Get("appId"):''
    router.push({ path: `/Custwechatinfo?appId=${appId}` });
  }
}
// 返回在vue模板中的调用接口
export default {
  handlezfGet: function(url, params, success, failure) {
    return handlezf("GET", url, params, success, failure);
  },
  handlezfPost: function(url, params, success, failure) {
    return handlezf("POST", url, params, success, failure);
  },
  handleSFGet: function(url, params, success, failure) {
    return handleSF("GET", url, params, success, failure);
  },

  handleSFSpeGet: function(url, params, success, failure) {
    return handleSFSpe("GET", url, params, success, failure);
  },
  handleSFPost: function(url, params, success, failure) {
    return handleSF("POST", url, params, success, failure);
  },
  handleSFSpePost: function(url, params, success, failure) {
    return handleSFSpe("POST", url, params, success, failure);
  },
  handleSignGet: function(url, params, success, failure) {
    return handleSign("GET", url, params, success, failure);
  },
  handleSignPost: function(url, params, success, failure) {
    return handleSign("POST", url, params, success, failure);
  },
  // 快递专用
  handleExpressGet: function(url, params, success, failure) {
    return handleExpress("GET", url, params, success, failure);
  },
  handleExpressPost: function(url, params, success, failure) {
    return handleExpress("POST", url, params, success, failure);
  },
  handleorderGet: function(url, params, success, failure) {
    return handleorderAxios("GET", url, params, success, failure);
  },
  handleorderPost: function(url, params, success, failure) {
    return handleorderAxios("POST", url, params, success, failure);
  },
  handleGet: function(url, params, success, failure) {
    return handleAxios("GET", url, params, success, failure);
  },
  handlePost: function(url, params, success, failure) {
    return handleAxios("POST", url, params, success, failure);
  },
  handleUserGet: function(obj, success, failure) {
    return handleUserAxios(
      "GET",
      obj.url,
      obj.params,
      obj.headers,
      success,
      failure
    );
  },
  handleUserPost: function(obj, success, failure) {
    return handleUserAxios(
      "POST",
      obj.url,
      obj.params,
      obj.headers,
      success,
      failure
    );
  },
  GetShare1: function(url, params, success, failure) {
    return Ajax("GET", url, params, success);
  },
  pay: function(url, params, success, failure) {
    return pay("GET", url, params, success);
  },
  dataStsOss: function(url, params, token, success, failure, err) {
    return handleAxiosSts("POST", url, params, token, success, failure, err);
  },
  rzCenterPost: function(url, params, success, failure) {
    return rzCenterAxios("POST", url, params, success);
  },
  handleGroYinGet: function(url, params, success, failure, err) {
    return handleAxiosGroYin("GET", url, params, success, failure, err);
  },
  handleGroYinPost: function(url, params, success, failure, err) {
    return handleAxiosGroYin("POST", url, params, success, failure, err);
  },
  handleGroYinCheWuGet: function(url, params, success, failure, err) {
    return handleAxiosGroYinCheWu("GET", url, params, success, failure, err);
  },
  handleGroYinCheWuPost: function(url, params, success, failure, err) {
    return handleAxiosGroYinCheWu("POST", url, params, success, failure, err);
  },
  handleGroYinJQPost: function(url, params, success, failure, err) {
    return handleAxiosGroYinJQ("POST", url, params, success, failure, err);
  },
  // ossCode: ossCode
};

// 参数过滤
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key];
    }
  }
  if (toType(o[key]) === "string") {
    o[key] = o[key].trim();
  } else if (toType(o[key]) === "object") {
    o[key] = filterNull(o[key]);
  } else if (toType(o[key]) === "array") {
    o[key] = filterNull(o[key]);
  }
  return o;
}

// 自定义判断元素类型JS
function toType(obj) {
  return {}.toString
    .call(obj)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase();
}

// 判断页面的显示逻辑
function pageIsShow(menu, code) {
  return JSONPath.query(menu, `$..Children[?(@.Code=='${code}')].Visible`)[0];
}

// 判断按钮的显示逻辑
function buttonIsShow(code, menu) {
  // return JSONPath("", menu, code)
}



// WEBPACK FOOTER //
// ./src/api/api.js